/* eslint-disable no-console */
import _ from 'lodash';

const normalTextStyle = 'font-weight: normal;';
const subjectStyle = 'background: #222; color: #bada55;font-weight: normal;';
const paramsTextStyle = 'font-size: 10px; font-weight: normal; color: gray';
const typeStyle = 'color: blue;';
const errorStyle = 'background: red; color: white; font-weight: bold;';

const stringifyDetail = data => {
  if (_.isEmpty(data)) return '';
  let value = JSON.stringify(data);
  if (value.length > 100) {
    value = value.substring(0, 100) + '...';
  }
  return value;
};

const hasOnlyThisProperty = (criteria, propertyName) => {
  const keys = _.keys(criteria);
  return keys.length === 1 && keys[0] === propertyName;
};

const getIdsFromCriteria = criteria => {
  if (_.isArray(criteria.id)) {
    return criteria.id;
  } else if (_.isObject(criteria.id)) {
    if (hasOnlyThisProperty(criteria.id, 'in')) {
      return criteria.id.in;
    }
  } else {
    return [criteria.id];
  }
};

const validateSearchResult = (queries, result) => {
  _.forEach(queries, query => {
    if (hasOnlyThisProperty(query.criteria, 'id') && !_.has(query, 'first')) {
      const ids = getIdsFromCriteria(query.criteria);
      if (!ids) {
        return;
      }

      const missingItems = _.filter(ids, id => {
        const isInCache = _.find(query.cache, cachedItem => cachedItem.id === id);

        if (isInCache) {
          // server may not return a known aggregate when version is still the current one
          return false;
        }
        return !_.find(result, r => r.id === id);
      });

      if (missingItems.length > 0) {
        throw new Error(
          `Queries did not result expected result'. Missing Items: ${JSON.stringify(
            missingItems
          )}. Queries: ${JSON.stringify(queries)}.` //  Original stack trace: ${query.debugInfo.stack}
        );
      }
    }
  });
};

const logOther = (functionName, params, res, duration) => {
  const msg = `%c✨ done in ${Math.round(
    duration
  )}ms %c${functionName.toUpperCase()}%c ${stringifyDetail(params)}`;

  console.groupCollapsed(msg, normalTextStyle, subjectStyle, paramsTextStyle);
  console.log('request', params);
  console.log('response', _.get(res, 'data', res));
  console.groupEnd(msg);
};

const logFile = (params, res, duration) => {
  const msg = `%c✨ done in ${Math.round(
    duration
  )}ms %cFILE%c ${params.operation.toUpperCase()} %c${params.key}`;

  console.groupCollapsed(msg, normalTextStyle, subjectStyle, typeStyle, normalTextStyle);
  console.log('request', params);
  console.log('response', res);
  console.groupEnd(msg);
};

const logMutation = (mutation, res, duration) => {
  const msg = `%c✨ done in ${Math.round(duration)}ms %cMUTATION%c ${mutation.commandName} %c${stringifyDetail(mutation.commandArgs)}`;

  console.groupCollapsed(msg, normalTextStyle, subjectStyle, typeStyle, paramsTextStyle);
  console.log('mutation', mutation);
  console.log('response', _.castArray(res.data)[0]);
  console.groupEnd(msg);
};

const logSearch = (params, res, duration) => {
  const aggregateInCacheCount = _.size(params.queries[0].cache);
  const subject = 'SEARCH ' + aggregateInCacheCount + '-' + _.size(res.data.data);
  const output = _.map(params.queries, q => _.omit(q, ['cache', 'debugInfo']));
  const types = _.map(output, o => o.typename).join('+');
  const msg = `%c✨ done in ${Math.round(duration)}ms %c${subject}%c ${types} %c${stringifyDetail(
    output
  )}`;

  console.groupCollapsed(msg, normalTextStyle, subjectStyle, typeStyle, paramsTextStyle);
  for (let i = 0; i < params.queries.length; i++) {
    console.log('query', params.queries[i]);
  }
  console.log('response', res.data);
  console.groupEnd(msg);
};

const logGet = (params, res, duration) => {
  const aggregateInCacheCount = _.filter(params.queries, q => q.version).length;
  const subject = 'GET ' + aggregateInCacheCount + '-' + _.size(res.data.data);
  const types = _.uniq(_.map(res.data.data, o => o._typename)).join('+');
  const msg = `%c✨ done in ${Math.round(duration)}ms %c${subject}%c ${types}`;

  console.groupCollapsed(msg, normalTextStyle, subjectStyle, typeStyle);
  for (let i = 0; i < params.queries.length; i++) {
    console.log('query', params.queries[i]);
  }
  console.log('response', res.data.data);
  console.groupEnd(msg);
};

const logError = (functionName, params, res) => {
  let errMsg = res.message;
  if (errMsg === 'Network Error') {
    errMsg =
      'Network error (CORS policy prevented getting XMLHttpRequest error detail. Run skyjs in cloud mode to get more information about these errors)';
  }

  const msg = `✨ %cERROR%c %c${functionName.toUpperCase()}%c ${errMsg}`;
  console.groupCollapsed(msg, errorStyle, normalTextStyle, subjectStyle, normalTextStyle);
  console.log('error', res);
  console.groupEnd(msg);
};

const browserFormat = (functionName, params, res, duration, options) => {
  if (res instanceof Error) {
    logError(functionName, params, res);
    return;
  }

  if (functionName === 'data-get') {
    logGet(params, res, duration);
    return;
  }

  if (functionName === 'data-search') {
    logSearch({ queries: [params.query] }, res, duration);
    if (options.validateResult) {
      validateSearchResult([params.query], res.data.data);
    }
    return;
  }

  if (functionName === 'data-mutate') {
    logMutation(params, res, duration);
    return;
  }

  if (functionName === 'file') {
    logFile(params, res, duration);
    return;
  }

  logOther(functionName, params, res, duration);
};

export default browserFormat;
